export default function UserCertification({ openModal, certificates, lang }: any) {

  return (
    <div className="bg-white p-4 rounded-xl border space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">{lang === "id" ? "Sertifikat" : "Certificate"}</h3>
        <button
          onClick={() => openModal("certificate")}
          className="text-primary hover:underline"
        >
          ✎ Edit
        </button>
      </div>

      {certificates.map((cert: any, idx: number) => (
        <div key={idx} className="p-2 rounded-xl border-2 space-y-1">
          <h4 className="text-lg font-semibold">{cert.title}</h4>

          <p className="text-sm">{cert.organization}</p>

          <p className="text-sm text-gray-500">
            {lang === "id"
              ? `${cert.issueDate} – ${cert.current ? "Sekarang" : cert.expDate || "-"}`
              : `${cert.issueDate} – ${cert.current ? "Present" : cert.expDate || "-"}`
            }
          </p>
        </div>
      ))}
    </div>
  );
}
